import { PortalIcon, type PortalIconProps } from './portal-icon';

/** Lock — sessions, sign-in security. */
export function LockIcon(props: PortalIconProps) {
  return (
    <PortalIcon {...props}>
      <rect x="5.6" y="10.4" width="12.8" height="9" rx="1.8" />
      <path d="M8.4 10.4V7.8a3.6 3.6 0 0 1 7.2 0v2.6" />
      <path d="M12 14v2.2" />
    </PortalIcon>
  );
}
